import { SizeProp } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import clsx from 'clsx'

interface LoaderProps {
	className?: string
	size?: SizeProp
}

export default function Loader({ className, size = 'lg' }: LoaderProps) {
	return (
		<div className={clsx('flex justify-center items-center', className)}>
			<FontAwesomeIcon icon={['fas', 'spinner']} size={size} spin className="text-white" />
		</div>
	)
}
